import PosterCard from './PosterCard'
import MovieList from './MovieList'

const HomePage = () => {
  return (
    <div>
      <PosterCard />
      <MovieList />
    </div>
  )
}

export default HomePage
